export const SET_SEAT = 'SEATING/SET_SEAT'
export const SET_SEATS = 'SEATING/SET_SEATS'
export const SET_PARTICIPANTS_SEAT = 'SEATING/SET_PARTICIPANTS_SEAT'
